// extracted by mini-css-extract-plugin
module.exports = {"textToSpeech":"textToSpeech_textToSpeech__iymhM"};